import { render, staticRenderFns } from "./InviteListModal.vue?vue&type=template&id=23999a96&scoped=true&"
import script from "./InviteListModal.vue?vue&type=script&lang=js&"
export * from "./InviteListModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteListModal.vue?vue&type=style&index=0&id=23999a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23999a96",
  null
  
)

export default component.exports